import * as React from 'react';
import { cn } from '@/lib/utils';

const Button = React.forwardRef(({ className, variant = 'default', size = 'default', ...props }, ref) => {
  const variants = {
    default:
      'rounded-full bg-primary text-white hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-300',
    secondary:
      'rounded-full bg-white text-primary border border-slate-200 hover:border-primary/50 hover:bg-slate-50 transition-all duration-300',
    ghost: 'rounded-full text-slate-600 hover:text-primary hover:bg-slate-100',
    accent: 'rounded-full bg-accent text-white hover:bg-accent/90 shadow-lg hover:shadow-xl transition-all duration-300',
  };

  const sizes = {
    default: 'px-8 py-3 text-base font-medium',
    sm: 'px-6 py-2 text-sm',
    lg: 'px-10 py-4 text-lg font-medium',
    icon: 'h-10 w-10',
  };

  return (
    <button
      className={cn(variants[variant], sizes[size], 'inline-flex items-center justify-center whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed', className)}
      ref={ref}
      {...props}
    />
  );
});
Button.displayName = 'Button';

export { Button };